<template>
  <div>
    <list-page>
      <h1 slot="model">案例展示</h1>
      <h3 slot="model_y">CASE PRESENTATION</h3>
      <template slot="list">
        <!-- v-if="newsData3.length != 0" -->
        <list>
          <div class="newtitle" slot="title">
            <p>典型案例<span>Case & Typical</span> </p>
            <router-link :to="'/NewPageList/3'"><span>MORE</span></router-link>
          </div>
          <template slot="listitem">
            <el-skeleton :loading="loading3">
              <template slot="template">
                <list-item-gj></list-item-gj>
                <list-item-gj></list-item-gj>
              </template>
              <template>
                <router-link :to="'/NewDetail/'+ item.id" target="_blank"
                  v-for="(item,index) in newsData3" :key="index"
                  v-if="index < 2">
                  <list-item :item="item"></list-item>
                </router-link>
              </template>
            </el-skeleton>
          </template>
        </list>
          <!-- v-if="newsData4.length != 0" -->
        <list>
          <div class="newtitle" slot="title">
            <p>科技项目<span>Case & Probject</span> </p>
            <router-link :to="'/NewPageList/4'"><span>MORE</span></router-link>
          </div>
          <template slot="listitem">
            <router-link :to="'/NewDetail/'+ item.id" target="_blank"
              v-for="(item,index) in newsData4" :key="index"
              v-if="index < 2">
              <list-item :item="item"></list-item>
            </router-link>
          </template>
        </list>
      </template>
    </list-page>
  </div>
</template>
  
<script>
  import  listPage from '@/view/components/listPage.vue'
  import  list from '@/view/components/list.vue'
  import  listItem from '@/view/components/listItem.vue'
  import  listItemGj from '@/view/components/listItemGj.vue'

import News from '@/api/api.js'
export default {
  data() {
    return {
      newsData3: [],
      newsData4: [],
      loading3: true
    };
  },
  components: {
    listPage,
    list,
    listItem,
    listItemGj
  },
  created() {
    this.getData(3)
    this.getData(4)
  },
  mounted() {
  },
  methods: {
    async getData(classId){
      this.searchDTO = {
        limit: 2,
        classId  //新闻分类
      };
      let res =await News.getNewList(this.searchDTO);
      this['newsData'+classId] = res.data;
      this['loading'+classId] = false
      // console.log('newsData'+classId,this['newsData'+classId])
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/view/webapp/Case.vue